import React, { useState, useEffect, useRef } from "react";
import { Textfit } from "react-textfit";

import EMBRULES from "./embRules";
import EmbAppliqueGuide from "./embAppliqueGuide";
import rApp from "./rapp";
import { util } from "./util";
import { filterVariants } from "./filterVariants";
import {
  BackCaretIcon,
  CaretIcon,
  CloseIcon,
  OverflowArrow,
  ForsythBadge,
  PonceBadge,
  PonceSvgContainer,
} from "./icons";
import EmbText from "./embText";
const visitorCountry = window.Shopify?.country || 'US'; // Defaults to 'US' if not available

// Hardcoded conversion rate for USD to CAD
const conversionRateCAD = 1.38;
const getCurrency = () => {
  const marketHandle =window.Shopify?.country || 'US';
  return marketHandle == 'CA' ? 'CAD' : 'USD';
};

const EmbVariantsApplique = (props) => {
  const params = new URLSearchParams(window.location.search);
  const selectedFont = props.singleFont;
  const smallMaxChar = props.productObject.tags.includes("embmaxchar:3");
  const bundleProduct = props.productObject.tags.filter((tag) =>
    tag.includes("bundle")
  );
  const isBundle = bundleProduct.length > 0;
  const embroideryOption = props.productOptionVals.filter((option) =>
    option.name.toLowerCase().includes("embroidery")
  );
  const styleOption = props.productOptionVals.filter(
    (option) =>
      option.name.toLowerCase().includes("color") ||
      option.name.toLowerCase().includes("pattern") ||
      option.name.toLowerCase().includes("piping") ||
      option.name.toLowerCase().includes("stitching") ||
      (option.name.toLowerCase().includes("style") &&
        !option.name.toLowerCase().includes("robe style")) ||
      option.name.toLowerCase().includes("robe size")
  );
  const hasStyleOption = styleOption.length > 0;
  const sizeOption = props.productOptionVals.filter(
    (option) =>
      (option.name.toLowerCase().includes("size") &&
        !option.name.toLowerCase().includes("rug size") &&
        !option.name.toLowerCase().includes("robe size")) ||
      option.name.toLowerCase().includes("towel type") ||
      option.name.toLowerCase().includes("robe style")
  );
  const hasSizeOption = sizeOption.length > 0;
  const embPos = props.embTag[0].split(":");
  const embPosClass = embPos[1] ? embPos[1] : "none";

  // TODO: MAKE COLOR & FONT RULES CMSABLE TO PREVENT DEV REQUIREMENT. AGREED UPON AS TICKET DURING DOWNTIME
  var embfontsInit = ["Forsyth", "Ponce"];
  let embfonts = [];

  if (!selectedFont) {
    var embColors = [ 
      // {
      //   appliqueName: "Tartan with Navy",
      //   name: "Navy",
      //   stroke: "#282f4b",
      //   fill: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/red-tartan-bg2.jpg?v=1728930561",
      //   background: "Tartan",
      // },
      {
        appliqueName: "Taupe Brown Liberty",
        name: "Taupe",
        stroke: "#AF9483",
        fill: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Katie-and-Millie-Ai-3.jpg?v=1724770749",
        background: "Liberty",
      },
      {
        appliqueName: "Spa Blue Liberty",
        name: "Spa Blue",
        stroke: "#91B6BB",
        fill: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Katie-and-Millie-Ai-3b.jpg?v=1724772900",
        background: "Liberty",
      },
      {
        appliqueName: "White with Soft White",
        name: "White",
        stroke: "#FFFFFF",
        fill: "#F4F5F2",
        background: "Soft White",
      },
      {
        appliqueName: "Sand with Soft White",
        name: "Sand",
        stroke: "#E0D4CA",
        fill: "#FFFFFF",
        background: "Soft White",
      },
      {
        appliqueName: "Green",
        name: "Green",
        stroke: "#778C79",
        fill: "#809F70",
        background: "Green",
      },
      {
        appliqueName: "Ballet Pink",
        name: "Ballet Pink",
        stroke: "#FACAD8",
        fill: "#FCE8DF",
        background: "Pink",
      },
      {
        appliqueName: "French Blue",
        name: "French Blue",
        stroke: "#78A0D4",
        fill: "#A3BDCA",
        background: "Blue",
      },
    ];

    let newlistEmbFonts = new Set(embfontsInit);
    embfonts = Array.from(newlistEmbFonts);
  } else {
    var embColors = [
      { name: "Light Blue", hex: "#D2E2F1" },
      { name: "Ballet Pink", hex: "#FACAD8" },
      { name: "Coral", hex: "#EEB4AD" },
      { name: "Bright Pink", hex: "#DE5B96" },
      { name: "Red", hex: "#BA1F31" },
      { name: "French Blue", hex: "#78A0D4" },
      { name: "Navy", hex: "#14334C" },
      { name: "Spa Blue", hex: "#91B6BB" },
      { name: "Green", hex: "#93AC96" },
      { name: "Emerald", hex: "#0C4F43" },
      { name: "White", hex: "#fff" },
      { name: "Sand", hex: "#DFD4C9" },
      { name: "Taupe", hex: "#AF9483" },
      { name: "Grey", hex: "#BFC2C6" },
      { name: "Black", hex: "#000" },
    ];
    embfonts = [selectedFont];
  }

  const embImages = props.productObject.images.filter((option) =>
    option.toLowerCase().includes("_emb")
  );
  const [embImgSrc, setEmbImgSrc] = useState(null);
  const [activeFont, setActiveFont] = useState(embfonts[0]);
  const [activeEmbColor, setActiveEmbColor] = useState(embColors[0]);
  const [maxChars, setMaxChars] = useState(3);
  const [maxLimit, setMaxLimit] = useState("1 Letter");
  const [defaultText, setDefaultText] = useState("wze");
  const [inputText, setInputText] = useState("");
  const [hasErrorText, setHasErrorText] = useState("");
  const [inputIsAllCaps, setInputIsAllCaps] = useState(true);
  const [activeQty, setActiveQty] = useState(1);
  const [activeSize, setActiveSize] = useState(
    hasSizeOption
      ? props.currentNonEmbVariant[`option${sizeOption[0]?.position}`]
      : null
  );
  const [activeVariant, setActiveVariant] = useState(null);
  const [visibleVariants, setVisibleVariants] = useState(null);
  const [defaultTab, setDefaultTab] = useState("applique");
  const [guideActive, setGuideActive] = useState(false);
  const [hasOverflowText, setHasOverflowText] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const embRefPreviewContainer = useRef(null);
  const embRefPreviewText = useRef(null);

  const toggleDropdown = (value) => {
    setShowDropdown(value);
  };

  const setSize = (value) => {
    setActiveSize(value);
    setShowDropdown(false);
  };

  const keyPressColor = (event, color) => {
    if (event.charCode == 13) {
      setActiveEmbColor(color);
    }
  };

  const keyPressVariant = (event, variant) => {
    if (event.charCode == 13) {
      setActiveVariant(variant);
    }
  };

  const keyPressFont = (event, font) => {
    if (event.charCode == 13) {
      setActiveFont(font);
    }
  };

  const keyPressSize = (event, size) => {
    if (event.charCode == 13) {
      setSize(size);
    }
  };

  const filterCurrentVariants = () => {
    const embVariants = filterVariants(
      props.productObject,
      embroideryOption[0]?.position,
      true,
      sizeOption[0]?.position,
      activeSize
    );

    setVisibleVariants(embVariants);

    // get and set the current embroidery variant that matches the preselected non-embroidery variant on pdp
    // also sets the active variant when switching sizes
    const variantToCompare =
      activeVariant === null ? props.currentNonEmbVariant : activeVariant;
    const preselectedVariant = embVariants.filter((variant) => {
      return (
        variant[`option${styleOption[0]?.position}`] ===
        variantToCompare[`option${styleOption[0]?.position}`]
      );
    });
    setActiveVariant(preselectedVariant[0]);
  };

  const addToCart = () => {
    let embroideryStyle = activeFont;
    if (
      props.productObject?.tags.includes("Ponce Large") &&
      activeFont === "Ponce"
    ) {
      embroideryStyle = "Ponce Large";
    } else if (
      props.productObject?.tags.includes("Ponce Small") &&
      activeFont === "Ponce"
    ) {
      embroideryStyle = "Ponce Small";
    }
    const data = {
      "Embroidery Text": inputIsAllCaps ? inputText.toUpperCase() : inputText,
      "Embroidery Color": activeEmbColor.name,
      "Embroidery Style": embroideryStyle,
      "Embroidery Applique Background": activeEmbColor.background, // need a way to make this an exclusive value from activeEmbColor
    };
    if (defaultTab === "icons") {
      data["Embroidery Color"] = "";
      data["Embroidery Text"] = "Icon";
    }

    rApp.MinicartComponent.addVariant(activeVariant.id, activeQty, data);

    setTimeout(() => {
      closeEmbModal();
    }, 500);

    var dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "add_to_cart_track",
      ecommerce: {
        currency: getCurrency(),
        value: Number(
          util
            .formatMoney(activeVariant.price, "${{amount}}")
            .replace("$", "")
            .replace(",", "")
        ),
        items: [
          {
            item_list_id: `${props.productObject.id}`,
            item_list_name: `${props.productObject.title}`,
            item_id: `${activeVariant.id}`,
            item_name: `${props.productObject.title}`,
            affiliation: "Weezie Towels",
            currency:getCurrency(),
            coupon: null,
            discount: activeVariant?.compare_at_price
              ? util
                  .formatMoney(activeVariant?.compare_at_price, "${{amount}}")
                  .replace("$", "")
                  .replace(",", "") -
                util
                  .formatMoney(activeVariant?.price, "${{amount}}")
                  .replace("$", "")
                  .replace(",", "")
              : 0,
            index: 0,
            item_brand: "Weezie Towels",
            item_category: `${props.productObject.type}`,
            item_category2: `${activeVariant.option1}`,
            item_category3: null,
            item_category4: null,
            item_variant: null,
            price: Number(
              util
                .formatMoney(
                  activeVariant.price,
                  "${{amount}}",
                  embroideryPricing
                )
                .replace("$", "")
                .replace(",", "")
            ),
            quantity: activeQty,
          },
        ],
      },
    });
  };

  const setActiveImg = () => {
    if (activeVariant !== null) {
      const embImage = embImages.filter((image) => {
        if (isBundle) {
          var currVariantName =
            activeVariant[`option${styleOption[0].position}`]
              .replace(/\s/g, "-")
              .replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "-")
              .toLowerCase() +
            "-" +
            activeVariant.option2
              .replace(/\s/g, "-")
              .replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "-")
              .toLowerCase();
        } else {
          var currVariantName = activeVariant[
            `option${styleOption[0].position}`
          ]
            .replace(/\s/g, "-")
            .replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "-")
            .toLowerCase();
        }
        return image.toLowerCase().includes(currVariantName);
      });

      setEmbImgSrc(embImage);
    }
  };

  const checkErrors = (text) => {
    let errorText = "";
    let spacesErrorText = "";
    let charMaxErrorText = "";

    if (text.length > 0) {
      // check for whitepace
      if (/[\s]/g.test(text) && !EMBRULES[activeFont].spaces) {
        spacesErrorText = "No spaces allowed.";
      }

      // check for Ardsley
      if (EMBRULES[activeFont].charLimitRules === "1,3" && text.length === 2) {
        charMaxErrorText = `${EMBRULES[activeFont].limitHint} required.`;
      }

      // check min/max char limits
      if (
        text.length > EMBRULES[activeFont].charMax ||
        text.length < EMBRULES[activeFont].charMin
      ) {
        charMaxErrorText = `${EMBRULES[activeFont].limitHint} required.`;
      }

      // has special characters and/or numbers
      if (/[^\w\s]|[\d]/gi.test(text) && !EMBRULES[activeFont].specialChars) {
        errorText = `No special characters or numbers allowed. ${charMaxErrorText}${
          spacesErrorText !== "" ? ` ${spacesErrorText}` : ""
        }`;
      } else {
        errorText = `${charMaxErrorText}${
          spacesErrorText !== "" ? ` ${spacesErrorText}` : ""
        }`;
      }
    }

    setHasErrorText(errorText);
  };
  const getUpdatedRules = (product, defaultRules) => {
    if (product?.tags.includes("ForsythSmall")) {
      const productSpecificRules = {
        Forsyth: {
          charLimitRules: "1",
          charMax: 1,
          charMin: 1,
          hint: "e.g. First Initial or Last Initial",
          limitHint: "1 letter",
          spaces: false,
          defaultText: "w",
          allCaps: true,
          specialChars: false,
        },
        Ponce: {
          charLimitRules: "1",
          charMax: 1,
          charMin: 1,
          hint: "e.g. First Initial or Last Initial",
          limitHint: "1 letter",
          spaces: false,
          defaultText: "w",
          allCaps: true,
          specialChars: false,
        },
      };
      return productSpecificRules;
    } else {
      return defaultRules;
    }
  };

  const updatedEMBRULES = getUpdatedRules(props.productObject, EMBRULES);

  const handleChange = ({ target }) => {
    let text = target.value;
    let currentRules = updatedEMBRULES[activeFont];
    let charMax = currentRules.charMax;

    // Strip spaces if the font doesn't support them
    if (!currentRules.spaces) text = text.replace(/\s/g, "");

    if (!currentRules.specialChars) {
      // Strip special characters and numbers
      text = text.replace(/[^\w\s]|[\d]/gi, "");
    } else {
      // Strip special characters except allowed ones
      text = text.replace(/[^!@#$%&‘’'-+\w\s]/gi, "");
    }

    // Ensure text length does not exceed charMax
    text = text.substring(0, charMax);

    checkErrors(text);
    if (text.length <= charMax || hasErrorText !== "") {
      setInputText(text);
    }
  };

  const embFontToggles = (current) => {
    setDefaultTab(current);
  };

  const keyPressFontToggle = (event, current) => {
    if (event.charCode == 13) {
      setDefaultTab(current);
    }
  };

  const guideToggle = (value) => {
    setGuideActive(value);
  };

  const closeEmbModal = () => {
    // clear params and replace with previously selected non-emb variant when closing
    const variant = props.productObject.variants[0];

    params.delete("embvariant");
    params.delete("personalized");
    params.delete("font");
    params.delete("color");
    params.delete("type");
    if (activeVariant.id === props.currentNonEmbVariant.id) {
      props.setMetaCurrentVariant(variant);
      params.set("variant", variant.id);
    } else {
      params.set("variant", props.currentNonEmbVariant.id);
    }
    window.history.replaceState({}, "", `${location.pathname}?${params}`);
    props.closeEmbModal();
  };

  const setUrl = () => {
    if (activeVariant !== null) {
      params.delete("variant");
      params.set("embvariant", activeVariant.id);
      params.set("personalized", inputText);
      params.set("font", activeFont);
      params.set("color", activeEmbColor.name);
      params.set("type", defaultTab);

      window.history.replaceState({}, "", `${location.pathname}?${params}`);
    }
  };

  useEffect(() => {
    filterCurrentVariants();
  }, [props, activeSize]);

  useEffect(() => {
    if (defaultTab === "applique" && !embfonts.includes(activeFont)) {
      setActiveFont(embfonts[0]);
    }
  }, [defaultTab]);

  useEffect(() => {
    if (defaultTab !== "icons") {
      let updatedEMBRULES = getUpdatedRules(props.productObject, EMBRULES);
      if (updatedEMBRULES.hasOwnProperty(activeFont)) {
        setDefaultText(updatedEMBRULES[activeFont].defaultText);
        setMaxChars(updatedEMBRULES[activeFont].charMax);
        setMaxLimit(updatedEMBRULES[activeFont].limitHint);
        setInputIsAllCaps(updatedEMBRULES[activeFont].allCaps);
        checkErrors(inputText);
        setInputText(inputText);
      }
    } else {
      setDefaultText("Icon");
    }
  }, [activeFont]);

  useEffect(() => {
    setActiveImg();
    setUrl();
  }, [activeVariant]);

  useEffect(() => {
    setTimeout(() => {
      const previewTextWidth =
        embRefPreviewText?.current?.getBoundingClientRect().width;
      const previewContainerWidth =
        embRefPreviewContainer?.current?.getBoundingClientRect().width;

      setHasOverflowText(previewTextWidth > previewContainerWidth);
    }, 0);
    setUrl();
  }, [inputText, activeFont, activeEmbColor]);

  useEffect(() => {
    // check if has embroidery url params when opened
    if (params.has("embvariant")) {
      const variantFromUrl = props.productObject.variants.filter(
        (variant) => variant.id === parseInt(params.get("embvariant"), 10)
      )[0];
      // set size / variant / emb text / emb color / emb font
      if (hasSizeOption)
        setActiveSize(variantFromUrl[`option${sizeOption[0]?.position}`]);
      setActiveVariant(variantFromUrl);
      setInputText(params.get("personalized"));
      setActiveFont(params.get("font"));
      // setDefaultTab(params.get("type"));
      setActiveEmbColor(
        embColors.filter((color) => color.name === params.get("color"))[0]
      );
    }
  }, [props.embVisibility]);
  const modalRef = useRef(null);
  useEffect(() => {
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === "childList") {

          mutation.addedNodes.forEach((node) => {
            // console.log("New child node added:", node);
            if (node.nodeType === 1 && node.matches(".embroidery-form")) {
              // console.log("Processing .gift-reggie-registry-button");

              // Temporarily disconnect observer to avoid infinite loop
              observer.disconnect();

              // Process the button
              gift_reggie.registry_button?.publishButton(node);

              // Reconnect observer after processing
              observer.observe(modalRef.current, {
                childList: true,
                subtree: true,
                attributes: true
              });
            }
          });

          // Handle removed nodes (if needed)
          mutation.removedNodes.forEach((node) => {
            console.log("Child node removed:", node);
          });
        }
      });
    });

    // Start observing the modal for child element changes
    if (modalRef.current) {
      observer.observe(modalRef.current, {
        childList: true, // Track child elements being added or removed
        subtree: true,   // Track changes in descendant nodes as well
        attributes: true // Track attribute changes
      });
    }

    // Clean up the observer when the component unmounts
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div
    ref={modalRef}
      className={`embroidery__modal  ${
        props.embVisibility ? "embroidery__modal--open" : ""
      }`}
    >
      <button
        onClick={() => closeEmbModal()}
        className="embroidery__modal__close type type--medium"
      >
        <BackCaretIcon />
        Back to Product
      </button>

      <div className="embroidery__close" onClick={() => closeEmbModal()}>
        <CloseIcon />
      </div>

      <div className="embroidery__inner">
        <div className="embroidery__block embroidery__block--image">
          <div className={`embroidery__image-wrap`}>
            {hasErrorText !== "" && (
              <div className="embroidery__image-error">
                <span>
                  Please review applique text and font selection.
                  <br />
                  Current selections are not supported.
                </span>
              </div>
            )}

            <div
              className={`embroidery__preview embroidery__preview--${embPosClass} embroidery__preview--${
                inputText.length
              }-${activeFont.toLowerCase()}`}
              ref={embRefPreviewContainer}
            >
              {/* hidden div for calculating text size / overflow */}
              <div
                className={`embroidery__preview-text embroidery__preview-text--overflow-calc embroidery__preview-text--${activeFont.toLowerCase()} embroidery__preview-text--${activeFont.toLowerCase()}--${embPosClass} embroidery__preview-text--${activeFont.toLowerCase()}--${
                  inputText.length
                }`}
                ref={embRefPreviewText}
              >
                {hasErrorText === "" && (
                  <EmbText
                    embRefPreviewContainer={embRefPreviewContainer}
                    embRefPreviewText={embRefPreviewText}
                    hasOverflowText={hasOverflowText}
                    calcText={true}
                    setHasOverflowText={(val) => setHasOverflowText(val)}
                    inputText={inputText}
                    defaultText={defaultText}
                  />
                )}
              </div>

              {/* hidden div for calculating text size / overflow */}
              <div
                className={`
                  embroidery__preview-text embroidery__preview-text--${
                    props.productObject.handle
                  } 
                  embroidery__preview-text--${activeFont.toLowerCase()} 
                  embroidery__preview-text--${activeFont.toLowerCase()}--${embPosClass} 
                  embroidery__preview-text--${activeFont.toLowerCase()}--${
                  inputText.length
                }
                  embroidery__preview-text--applique
                `}
                style={{
                  color: activeEmbColor.stroke,
                  "--fill-backgrund": activeEmbColor.fill.startsWith("#")
                    ? activeEmbColor.fill
                    : `url(${activeEmbColor.fill})`,
                }}
              >
                {hasErrorText === "" && defaultTab !== "icons" && (
                  <EmbText
                    embRefPreviewContainer={embRefPreviewContainer}
                    embRefPreviewText={embRefPreviewText}
                    hasOverflowText={hasOverflowText}
                    setHasOverflowText={(val) => setHasOverflowText(val)}
                    inputText={inputText}
                    defaultText={defaultText}
                  />
                )}

                {activeFont === "Ponce" && (
                  <PonceSvgContainer
                    stroke={activeEmbColor.stroke}
                    fill={activeEmbColor.fill}
                  />
                )}
              </div>
            </div>

            {embImgSrc !== "" && (
              <img
                src={embImgSrc}
                alt={
                  activeVariant !== null
                    ? activeVariant[`option${styleOption[0].position}`]
                    : ""
                }
              />
            )}
          </div>
        </div>

        <div className="embroidery__block embroidery__block--controls">
          <div className="embroidery__block-inner">
            <div className="embroidery__header">
              <h2 className="medium">{props.productObject.title}</h2>
              <div className="embroidery__pricing type">
                {activeVariant?.compare_at_price &&
                activeVariant?.compare_at_price > activeVariant?.price ? (
                  <>
                    <s>
                      {util
                        .formatMoney(
                          activeVariant?.compare_at_price,
                          "${{amount}}"
                        )
                        .replace(".00", "")}
                    </s>
                    <span>
                      {util
                        .formatMoney(activeVariant?.price, "${{amount}}")
                        .replace(".00", "")}{visitorCountry === 'CA' && ' CAD'}
                    </span>
                    <p className="type--small">
                      {Math.floor(
                        100 -
                          100 *
                            Math.abs(
                              activeVariant?.price /
                                activeVariant?.compare_at_price
                            )
                      )}
                      % off
                    </p>
                  </>
                ) : (
                  <>
                    <span>
                      {util
                        .formatMoney(activeVariant?.price, "${{amount}}")
                        .replace(".00", "")}{visitorCountry === 'CA' && ' CAD'}
                    </span>
                  </>
                )}

                {props?.discountMessage && (
                  <p className="product__discount-message type type--small">
                    {props?.discountMessage}
                  </p>
                )}
              </div>
              <h3 className="x-small">Choose your text &amp; style</h3>
            </div>

            {!selectedFont && (
              <>
                {smallMaxChar === false && (
                  <ul className="embroidery__tabs">
                    <li
                      className={
                        "embroidery__tabs__item type type--medium" +
                        `${defaultTab === "applique" ? " current" : ""}`
                      }
                      tabIndex="0"
                      onKeyPress={(event) =>
                        keyPressFontToggle(event, "applique")
                      }
                      onClick={() => embFontToggles("applique")}
                    >
                      Applique
                    </li>
                  </ul>
                )}
              </>
            )}

            <div className="embroidery__fonts">
              <div className="embroidery__fonts__inner">
                {embfonts.length >= 5 && (
                  <OverflowArrow elClass="embroidery__fonts__arrow" />
                )}
                {defaultTab === "applique" && (
                  <>
                    {embfonts.map((font) => (
                      <div className="embroidery__font-block" key={font}>
                        <span
                          className={`embroidery__font-btn embroidery__font-btn--applique ${
                            activeFont === font
                              ? "embroidery__font-btn--active"
                              : ""
                          }`}
                          tabIndex="0"
                          onKeyPress={(event) => keyPressFont(event, font)}
                          onClick={() => setActiveFont(font)}
                        >
                          {font === "Forsyth" && (
                            <ForsythBadge elClass="embroidery__font-btn__icon embroidery__font-btn__icon--applique" />
                          )}

                          {font === "Ponce" && (
                            <PonceBadge elClass="embroidery__font-btn__icon embroidery__font-btn__icon--applique" />
                          )}

                          {font}
                        </span>
                      </div>
                    ))}
                  </>
                )}

                {embfonts.length >= 5 && <span className="spacer"></span>}
              </div>
            </div>

            <div className="embroidery__instructions">
              <p className="type type--medium type--bold">{maxLimit}</p>
              {defaultTab === "applique" &&
                updatedEMBRULES[activeFont]?.hint && (
                  <p className="type type--medium">
                    {updatedEMBRULES[activeFont].hint}.
                  </p>
                )}
            </div>

            <div className="embroidery__input-wrap">
              <input
                className={`embroidery__input ${
                  inputIsAllCaps ? "embroidery__input--allcaps" : ""
                } embroidery__input--haserror-${hasErrorText !== ""}`}
                type="text"
                placeholder={defaultText}
                maxLength={maxChars}
                value={inputText}
                onChange={(e) => handleChange(e)}
              />

              {hasErrorText !== "" && (
                <span className="embroidery__input-errortext">
                  {hasErrorText}
                </span>
              )}
            </div>

            <button
              onClick={() => guideToggle(!guideActive)}
              role="button"
              aria-haspopup="true"
              className="embroidery__guide-toggle btn btn--text"
            >
              Custom Embroidery Guide
            </button>

            <div className="embroidery__header">
              <h3 className="x-small">Choose your color</h3>
            </div>

            <div className="product__variants__row product__variants__row--full">
              <div className="product__variants__row-block">
                <p className="product__variants__label">
                  <span className="product__variants__option type type--medium">
                    Applique Color:
                  </span>
                  &nbsp;
                  <span className="product__variants__selected-option type type--medium">
                    {activeEmbColor.appliqueName}
                  </span>
                </p>
              </div>

              <div className="product__variants__row-block product__variants__row-block--static">
                {embColors !== null && embColors.length >= 8 && (
                  <OverflowArrow elClass="embroidery__fonts__arrow" />
                )}

                <div className="product__variants__options-wrap no-wrap">
                  {embColors.map((color) => (
                    <div className="product__variants__item" key={color.stroke}>
                      <div
                        tabIndex="0"
                        title={color.name}
                        className={`product__variants__item-inner ${
                          color.name === activeEmbColor.name ? "current" : ""
                        } rotate-colors`}
                        onKeyPress={(event) => keyPressColor(event, color)}
                        onClick={() => setActiveEmbColor(color)}
                      >
                        <div
                          class=" half half-top top"
                          style={{ backgroundColor: color.stroke }}
                        ></div>
                        <div
                          class=" half half-bottom bottom"
                          style={
                            color.fill.startsWith("#")
                              ? { backgroundColor: color.fill }
                              : { backgroundImage: `url(${color.fill})` }
                          }
                        ></div>
                      </div>
                    </div>
                  ))}

                  <span className="spacer"></span>
                </div>
              </div>
            </div>

            {hasStyleOption && (
              <div className="product__variants__row product__variants__row--full">
                <div className="product__variants__row-block">
                  <p className="product__variants__label">
                    <span className="product__variants__option type type--medium">
                      {styleOption[0]?.name}:
                    </span>
                    &nbsp;
                    <span className="product__variants__selected-option type type--medium">
                      {activeVariant !== null &&
                        activeVariant[`option${styleOption[0].position}`]}

                      {activeVariant !== null && (
                        <>
                          {activeVariant.available &&
                            props.productData.find(
                              (obj) => obj.id === activeVariant.id
                            ).inventory_quantity <= 0 && (
                              <span className="sold-out">
                                {" "}
                                •{" "}
                                {
                                  props.productData.find(
                                    (obj) => obj.id === activeVariant.id
                                  ).metafields.variant_state_message
                                }
                              </span>
                            )}
                          {!activeVariant.available && (
                            <span className="sold-out"> • Sold Out</span>
                          )}
                        </>
                      )}
                    </span>
                  </p>
                </div>

                <div className="product__variants__row-block product__variants__row-block--static">
                  {visibleVariants !== null && visibleVariants.length >= 8 && (
                    <OverflowArrow elClass="embroidery__fonts__arrow" />
                  )}

                  <div
                    className={`product__variants__options-wrap ${
                      visibleVariants !== null &&
                      visibleVariants.length >= 8 &&
                      "no-wrap"
                    }`}
                  >
                    {visibleVariants !== null &&
                      visibleVariants.map((variant, index) => (
                        <div
                          className={
                            "product__variants__item" +
                            `${variant.available ? "" : " sold-out"}`
                          }
                          key={variant.id}
                        >
                          <div
                            tabIndex="0"
                            title={variant.title}
                            variantid={variant.id}
                            className={`product__variants__item-inner ${
                              activeVariant?.id === variant.id ? "current" : ""
                            }`}
                            onKeyPress={(event) =>
                              keyPressVariant(event, variant)
                            }
                            onClick={() => setActiveVariant(variant)}
                          >
                            {props.productData.find(
                              (obj) => obj.id === variant.id
                            ).swatch && (
                              <img
                                alt={
                                  `${
                                    props.productData.find(
                                      (obj) => obj.id === variant.id
                                    ).title
                                  }` + " color swatch"
                                }
                                src={
                                  props.productData.find(
                                    (obj) => obj.id === variant.id
                                  ).swatch
                                }
                              ></img>
                            )}
                          </div>
                        </div>
                      ))}

                    {visibleVariants !== null &&
                      visibleVariants.length >= 8 && (
                        <span className="spacer"></span>
                      )}
                  </div>
                </div>
              </div>
            )}

            {hasSizeOption && !isBundle && (
              <div className="product__variants__row">
                <div className="product__variants__row-block">
                  <p className="product__variants__label">
                    <span className="product__variants__option type type--medium">
                      {sizeOption[0]?.name}:
                    </span>
                    &nbsp;
                    <span className="product__variants__selected-option type type--medium">
                      {activeSize}
                    </span>
                  </p>
                </div>

                <div className="product__variants__row-block">
                  <div className="product__variants__options-wrap">
                    {sizeOption[0].values.map((size) => (
                      <div
                        className="product__variants__item product__variants__item--right"
                        key={size}
                      >
                        <div
                          tabIndex="0"
                          className={`product__variants__item-inner ${
                            size === activeSize ? "current" : ""
                          }`}
                          onKeyPress={(event) => keyPressSize(event, size)}
                          onClick={() => setSize(size)}
                        >
                          {size}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {isBundle && (
              <div className="product__variants__row product__variants__row--inset product__variants__row--border-top">
                <div className="product__variants__row-block product__variants__row-block--select">
                  <p className="product__variants__label type type--medium">
                    <span className="product__variants__option type type--medium">
                      {sizeOption[0]?.name}:
                    </span>
                  </p>

                  <div className="product__variants__select-wrap">
                    <span
                      className={`type type--medium ${showDropdown}`}
                      tabIndex="0"
                      onKeyPress={(event) => {
                        if (event.charCode == 13) {
                          toggleDropdown(!showDropdown);
                        }
                      }}
                      onClick={() => toggleDropdown(!showDropdown)}
                    >
                      {activeSize}
                      <CaretIcon />
                    </span>
                    <ul className={`product__variants__list ${showDropdown}`}>
                      {sizeOption[0].values.map((size) => {
                        if (sizeOption[0]?.name === "Robe Size") {
                          var optionPrice = `${
                            props.productObject.variants.find(
                              (obj) => obj.option1 === size
                            ).price
                          }`;
                        } else {
                          var optionPrice = `${
                            props.productObject.variants.find(
                              (obj) => obj.option2 === size
                            ).price
                          }`;
                        }

                        return (
                          <li
                            className="product__variants__item product__variants__item--right type type--medium"
                            key={size}
                            tabIndex="0"
                            onKeyPress={(event) => {
                              if (event.charCode == 13) {
                                setSize(size);
                              }
                            }}
                            onClick={() => setSize(size)}
                          >
                            {size}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            )}

            <div className="product__buttons product__buttons--full">
              <div className="product__buttons__group">
                {activeVariant?.available ? (
                  <>
                    {(defaultTab !== "icons") & (inputText === "") ||
                    hasErrorText !== "" ? (
                      <p className="product__buttons__error type type--medium">
                        Please enter your applique text to add to bag
                      </p>
                    ) : null}
                    <div className="product__buttons__wrap">
                      <div className="product__buttons__group product__buttons__group--cart">
                        <button
                          disabled={
                            (defaultTab !== "icons") & (inputText === "") ||
                            hasErrorText !== ""
                          }
                          onClick={() => addToCart()}
                          className="product__buttons__add btn btn--full btn--navy add-to-cart"
                        >
                          {props.productData.find(
                            (obj) => obj.id === activeVariant.id
                          ).inventory_quantity <= 0
                            ? "Preorder"
                            : "Add to Bag"}{" "}
                          •{" "}
                          <span>
                            {util
                              .formatMoney(activeVariant?.price, "${{amount}}")
                              .replace(".00", "")}
                          </span>
                          {activeQty > 1 && <span>Each</span>}
                        </button>
                      </div>
                      <div className="product__quantity">
                        <div className="product__count">
                          <button
                            onClick={() =>
                              setActiveQty(activeQty <= 1 ? 1 : activeQty - 1)
                            }
                            className="product__count__button product__count__button--minus"
                            aria-label="Product quantity decrease"
                          >
                            <svg
                              viewBox="0 0 15 2"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <line
                                x1="0.5"
                                y1="1.03623"
                                x2="14.5"
                                y2="1.03623"
                                stroke="#14334C"
                                strokeWidth="1.2"
                              />
                            </svg>
                          </button>

                          <span className="product__count__number type">
                            {activeQty}
                          </span>

                          <button
                            onClick={() => setActiveQty(activeQty + 1)}
                            className="product__count__button product__count__button--plus"
                            aria-label="Product quantity increase"
                          >
                            <svg viewBox="0 0 15 14" fill="none">
                              <line
                                x1="7.46377"
                                y1="2.62269e-08"
                                x2="7.46377"
                                y2="14"
                                stroke="#14334C"
                                strokeWidth="1.2"
                              />
                              <line
                                x1="0.5"
                                y1="7.03623"
                                x2="14.5"
                                y2="7.03623"
                                stroke="#14334C"
                                strokeWidth="1.2"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* TODO: LOOK INTO GIFTREGGIE INTEGRATION BEFORE READDING THIS */}
                    {/* <button
                      onClick={() => registryTrigger()}
                      className="product__buttons__registry btn btn--full"><span>Add to Registry</span>
                    </button> */}

                    <form
                      className={
                        defaultTab !== "icons" &&
                        inputText !== "" &&
                        hasErrorText === ""
                          ? "embroidery-form"
                          : "embroidery-form embroidery-form--disabled"
                      }
                      method="post"
                      action="/cart/update"
                      acceptCharset="UTF-8"
                      encType="multipart/form-data"
                    >
                      <input name="id" type="hidden" value={activeVariant.id} />
                      {defaultTab !== "icons" && (
                        <>
                          <input
                            name="properties[Embroidery Text]"
                            type="hidden"
                            value={
                              inputIsAllCaps
                                ? inputText.toUpperCase()
                                : inputText
                            }
                          />
                          <input
                            name="properties[Embroidery Color]"
                            type="hidden"
                            value={activeEmbColor.name}
                          />
                        </>
                      )}
                      <input
                        name="properties[Embroidery Style]"
                        type="hidden"
                        value={activeFont}
                      />
                      <input
                        name="properties[Embroidery Applique Background]"
                        type="hidden"
                        value={activeEmbColor.name}
                      />
                      <div className="gift-reggie-buttons">
                        <div className="gift-reggie-registry-button">
                          <input
                            type="hidden"
                            className="gift-reggie-hook"
                            value=""
                          />
                        </div>
                      </div>
                    </form>
                  </>
                ) : (
                  <button
                    onClick={() => addToCart()}
                    className="product__buttons__add btn btn--full btn--navy sold-out"
                  >
                    Sold Out
                  </button>
                )}

                {/* TODO: COMMENTED OUT AS PART OF ORIGINAL DESIGN PIVOT */}
                {/* <button className="product__wishlist-add">
                  <HeartIcon elClass="product__wishlist-add__icon" />
                </button> */}
              </div>
            </div>

            <div className="embroidery__disclaimer">
              <p className="type type--small">
                Please note the preview is approximate. Customized items cannot
                be exchanged or returned and may require additional time to
                process.
              </p>
            </div>

            <div className="embroidery__contact">
              <p className="type type--medium">Still have questions?</p>
              <p className="type type--medium">
                Email{" "}
                <a href="mailto:holler@weezietowels.com">
                  holler@weezietowels.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      {guideActive && <EmbAppliqueGuide toggle={guideToggle} />}
    </div>
  );
};

export default EmbVariantsApplique;
